export default "__VITE_ASSET__CUI9kl_A__"